export default __webpack_public_path__ + "static/media/Ballroll_00335.f7b87da1.png";